(function($) {
    "use strict";

    $('[gr-modal]').each(function() {
        var modal = $(this).attr('gr-modal');

        $(this).magnificPopup({
            items: {
                src: modal,
                type: 'inline'
            },
            midClick: true
        });
    });

})(jQuery);


(function() {
  'use strict';

  var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol ? 'symbol' : typeof obj;
  };

  var Toggables = function (window, document) {
    'use strict';
    var triggers, trgets, options = {}, defaults = {
      toggled_class: 'is-toggled',
      trigger_selector: '.toggable-trigger',
      target_selector: '.toggable-target',
      on_toggled: false,
      off_toggled: false
    };
    var _setOptions = function _setOptions(config) {
      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
        for (var key in defaults) {
          if (!defaults.hasOwnProperty(key)) {
            continue;
          }
          options[key] = typeof config[key] === 'undefined' ? defaults[key] : config[key];
        }
      }
    };
    var _openTrget = function _openTrget(trigger, trget) {
      trigger.classList.add(options.toggled_class);
      trigger.toggled = true;
      if (typeof options.on_toggled === 'function')
        options.on_toggled(trigger, trget);
    };
    var _closeTrget = function _closeTrget(trigger, trget) {
      trigger.classList.remove(options.toggled_class);
      trigger.toggled = false;
      if (typeof options.off_toggled === 'function')
        options.off_toggled(trigger, trget);
    };
    var _toggleTrget = function _toggleTrget(trigger, trget) {
      trigger.toggled ? _closeTrget(trigger, trget) : _openTrget(trigger, trget);
    };
    var _getElements = function _getElements() {
      triggers = document.querySelectorAll(options.trigger_selector);
      trgets = document.querySelectorAll(options.target_selector);
    };
    var _bindListeners = function _bindListeners() {
      var len = triggers.length === trgets.length ? triggers.length : false;
      var _loop = function _loop(i) {
        triggers[i].toggled = false;
        triggers[i].addEventListener('click', function () {
          _toggleTrget(this, trgets[i]);
        });
      };
      for (var i = 0; i < len; i++) {
        _loop(i);
      }
    };
    var init = function init(config) {
      _setOptions(config);
      _getElements();
      _bindListeners();
    };
    var publicAPI = { init: init };
    return publicAPI;
  }(window, document);

  Toggables.init({
    on_toggled: function on_toggled(trigger, trget) {
      trget.style.height = trget.scrollHeight + 'px';
    },
    off_toggled: function off_toggled(trigger, trget) {
      trget.style.height = 0;
    }
  });

  var custom_selects = document.querySelectorAll('[custom-select]');

  var update_value = function update_value(self) {
    var select = self.querySelector('select');

    self.setAttribute('custom-select', select.value);
    self.classList.add('is-selected');
  };

  for (var i = 0; i < custom_selects.length; i++) {
    (function(i) {
      custom_selects[i].addEventListener('change', function() {
        update_value(this);
      });
    })(i);
  }

})();
